/**
 * @author Alejandro
 * @param {Array} playList
 * @param {Array<number>} selectedTime
 * @param {Array} valuesToFilter
 * @param {Object} playValuesIndex
 * @param {number} teamId
 * @return {{}}
 */
export function getLocalVsVisitorData(playList, selectedTime, valuesToFilter, playValuesIndex, teamId) {
  const resultData = {};
  for (const [k, v] of Object.entries(valuesToFilter)) {
    resultData[k] = {
      translationKey: v.translationKey,
      // [local, visitor]
      data: [0, 0],
      categoryIds: v.categoryIds,
      singleName: v.singleName,
    };
  }
  for (const play of playList) {
    if (selectedTime.includes(play[playValuesIndex.section])) {
      for (const key of Object.keys(valuesToFilter)) {
        if (
          findPlayInCategories(
            valuesToFilter[key].categoryIds,
            play[playValuesIndex.categoryId],
            play[playValuesIndex.teamId],
            teamId,
          )
        ) {
          // play vlCombination has values: Local = 1 , Visitor = 2
          const localOrVisitor =
            play[playValuesIndex.teamId] === teamId
              ? play[playValuesIndex.playingAs] - 1
              : Math.abs(play[playValuesIndex.playingAs] - 2);
          resultData[key].data[localOrVisitor]++;
        }
      }
    }
  }
  return resultData;
}

function findPlayInCategories(categories, playCategoryId, playTeamId, teamId) {
  return categories.find(category => {
    let categoryAux = 0;
    if (typeof category === 'string') {
      if (playTeamId) {
        categoryAux = Number(category.split('_').shift());
        return categoryAux === playCategoryId && playTeamId !== teamId;
      }
    } else {
      return category === playCategoryId && playTeamId === teamId;
    }
    return false;
  });
}
